import { useSectorMark } from '@hooks/useSectorMarkHook';
import { Popover } from 'antd';

const provinceRowRender = (text: string) => {
  if (!text) {
    return '';
  }
  const rowStr = text.split(':').join(' , ');
  const content = text.split(':').map((v) => {
    return (
      <div className="province-item" key={v}>
        {v}
      </div>
    );
  });
  return (
    <Popover
      // trigger="click"
      content={<div className="province-popover-wrap">{content}</div>}
    >
      <div className="text-ellipsis-2-row">{rowStr}</div>
    </Popover>
  );
};

export const use_ROLESALESN_COLUMNS = () => {
  const sectorMark = useSectorMark();
  return [
    {
      title: '姓名',
      dataIndex: 'realName',
      key: 'realName'
    },
    {
      title: sectorMark,
      dataIndex: 'userTypesName',
      key: 'userTypesName'
    },
    {
      title: '省份',
      dataIndex: 'provinceName',
      key: 'provinceName',
      width: 200,
      render: provinceRowRender
    },
    {
      title: '城市',
      dataIndex: 'cityName',
      key: 'cityName',
      width: 200,
      render: provinceRowRender
    },
    {
      title: '手机号码',
      dataIndex: 'mobile',
      key: 'mobile'
    },
    {
      title: '邮箱',
      dataIndex: 'email',
      key: 'email'
    },
    {
      title: 'N+1',
      dataIndex: 'n1Name',
      key: 'n1Name'
    },
    {
      title: 'N+2',
      dataIndex: 'n2Name',
      key: 'n2Name'
    },
    {
      title: 'N+3',
      dataIndex: 'n3Name',
      key: 'n3Name'
    },
    {
      title: 'N+4',
      dataIndex: 'n4Name',
      key: 'n4Name'
    }
  ];
};
